import { Component, EventEmitter, Output, input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounceTime, map } from 'rxjs';
import { IdReferenceDto, TenantDetailDto } from '@artemis-software/wr-api';
import { userToIdReference } from '@/utils/id-reference';
import { InspectionDashboardMode } from '@pages/inspection-dashboard-page/inspection-dashboard-mode';

export interface InspectionDashboardFilter {
  technicianReference?: IdReferenceDto;
  clerkReference?: IdReferenceDto;
  tenantId?: string;
  buildingId?: string;
  teamId?: string;
  regionId?: string;
  assignedToCurrentUser?: boolean;
  hideNeverInspected?: boolean;
}

@Component({
  standalone: false,
  selector: 'wr-inspection-dashboard-filter',
  templateUrl: './inspection-dashboard-filter.component.html',
  styleUrls: ['./inspection-dashboard-filter.component.scss'],
})
export class InspectionDashboardFilterComponent {
  readonly mode = input<InspectionDashboardMode>('overdue');

  @Output()
  filterChange = new EventEmitter<InspectionDashboardFilter>();

  readonly form = new FormGroup({
    assignedToCurrentUser: new FormControl(true),
    hideNeverInspected: new FormControl(true),
    technician: new FormControl(),
    clerk: new FormControl(),
    tenantId: new FormControl(),
    building: new FormControl(),
    region: new FormControl(),
    team: new FormControl(),
  });

  readonly regionId$ = this.form.controls['region'].valueChanges.pipe(map((region) => region?.id));

  constructor() {
    this.form.controls['assignedToCurrentUser'].valueChanges.subscribe((assignedToCurrentUser) => {
      if (assignedToCurrentUser) {
        this.form.controls['technician'].disable({ emitEvent: false });
        this.form.controls['clerk'].disable({ emitEvent: false });
      } else {
        this.form.controls['technician'].enable({ emitEvent: false });
        this.form.controls['clerk'].enable({ emitEvent: false });
      }
    });
    this.form.controls['technician'].disable({ emitEvent: false });
    this.form.controls['clerk'].disable({ emitEvent: false });

    this.form.controls['tenantId'].valueChanges.subscribe(() => {
      this.form.controls['building'].setValue(undefined);
    });

    this.form.valueChanges.pipe(debounceTime(100)).subscribe((value) => {
      const assignedToCurrentUser = !!value.assignedToCurrentUser;
      this.filterChange.next({
        assignedToCurrentUser,
        hideNeverInspected: !!value.hideNeverInspected,
        technicianReference: assignedToCurrentUser ? undefined : userToIdReference(value.technician),
        clerkReference: assignedToCurrentUser ? undefined : userToIdReference(value.clerk),
        tenantId: value.tenantId,
        buildingId: value.building?.id,
        teamId: value.team?.id,
        regionId: value.region?.id,
      });
    });
    this.filterChange.next({ assignedToCurrentUser: true, hideNeverInspected: true });
  }

  protected readonly TenantTypeEnum = TenantDetailDto.TypeEnum;
}
